import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { HtmlService } from '../../../../../../services/html.service';

@Component({
    selector: 'pdf-resource',
    template: require('./pdf-resource.component.html'),
})
export class PDFResourceComponent implements OnChanges {
    @Input() id: number;
    @Input() hidepdf: boolean;
    srcUrl: SafeResourceUrl;
    label: string;

    constructor(private htmlService: HtmlService, private domSanitizer: DomSanitizer) { }

    ngOnChanges() {
        let url = this.htmlService.getResourceUrl(this.id);
        this.srcUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);

        this.htmlService.getResourceTranscript(this.id).subscribe(resourceDto => {
            if (!this.hidepdf) {
                if (resourceDto.Name.includes('notoolbar')) {
                    url += '#toolbar=0';
                    this.srcUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
                }
            } else {
                this.label = resourceDto.Name;
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/pdf-resource/pdf-resource.component.ts